import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import NotificationList from "@/features/notifications/NotificationList";

export default function NotificationIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Notifications",
          },
        ]}
      />

      <NotificationList />
    </>
  );
}
